import TabSwitcherWeb from "@components/switcher/TabSwitcherWeb";
import { isPaysonicHost } from "src/config/deploymentConfig";
import PlatformBalances from "./platform-balances/PlatformBalances";
import UserBalances from "./user-balances/UserBalances";

const BalancesTabs = () => {
  const isPaysonic = isPaysonicHost();

  const balanceTabs = isPaysonic
    ? [{ label: "User Balances", component: <UserBalances /> }]
    : [
        { label: "User Balances", component: <UserBalances /> },
        { label: "Platform Balances", component: <PlatformBalances /> },
      ];

  return (
    <div className="flex flex-col h-full">
      <div className="h-[70px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 pl-[20px]">
        <div className="flex flex-row justify-between items-center w-full mr-4">
          <p className="text-text-base text-[14px] font-semibold">Balances</p>
        </div>
      </div>
      <div className="flex-1 overflow-hidden mt-4 mx-4">
        <TabSwitcherWeb tabs={balanceTabs} full={true} />
      </div>
    </div>
  );
};

export default BalancesTabs;
